'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nav_history_chart_parent = require('./nav_history_chart_parent');

var _nav_history_chart_parent2 = _interopRequireDefault(_nav_history_chart_parent);

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _ramda = require('ramda');

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _number_utility = require('common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _functional_utility = require('common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _pathOr = require('ramda/src/pathOr');

var _pathOr2 = _interopRequireDefault(_pathOr);

var _belgian_tis_rates_card = require('./belgian_tis_rates_card');

var _belgian_tis_rates_card2 = _interopRequireDefault(_belgian_tis_rates_card);

var _pricing_composition_history = require('./pricing_composition_history');

var _pricing_composition_history2 = _interopRequireDefault(_pricing_composition_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundHistoricalPrices = function (_React$Component) {
  _inherits(FundHistoricalPrices, _React$Component);

  function FundHistoricalPrices(props) {
    _classCallCheck(this, FundHistoricalPrices);

    var _this = _possibleConstructorReturn(this, (FundHistoricalPrices.__proto__ || Object.getPrototypeOf(FundHistoricalPrices)).call(this, props));

    _this.tooltipImpl = _this.tooltipImpl.bind(_this);
    return _this;
  }

  _createClass(FundHistoricalPrices, [{
    key: 'activeCardScrollHandler',
    value: function activeCardScrollHandler() {
      return null;
    }
  }, {
    key: 'tooltipImpl',
    value: function tooltipImpl(formattedItem, intl, numberFormat) {
      var text = "<div style= 'text-align:left'>";
      text += "<div id='testchart' class='caption' style='font-weight:100'>" + formattedItem.formattedDate + "</div>";
      text += "<div style='font-weight:100'>" + _string_utility2.default.getLocalizedString(intl, 'Market-based NAV', 'pdp-historical-market-nav-chart-tooltip') + ": <span class='caption' style='font-weight:400'>" + formattedItem.formattedValue + "</span></div>";

      if (!(0, _ramda.includes)('ACCUMLATION_LVNAV_CNAV', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund))) {
        text += "<div style='font-weight:100'>" + _string_utility2.default.getLocalizedString(intl, 'Difference between constant NAV and market based NAV', 'pdp-historical-diff-between-cnav-marketnav-chart-tooltip') + ": <span class='caption' style='font-weight:400'>" + _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(formattedItem.shareclassMarketBasedNAVBasisPointDifferenceValue, 0)), numberFormat) + _string_utility2.default.getLocalizedString(intl, ' bps', 'pdp-chart-bps-label') + "</span></div>";
      }

      text += "</div>";
      return text;
    }
  }, {
    key: 'renderPricingCompositionHistoryCard',
    value: function renderPricingCompositionHistoryCard() {
      if (!(0, _functional_utility.doesVisibleDataPointContains)("SHOW_NAV_COMPOSITION_TABLE", this.props)) {
        return null;
      }

      return _react2.default.createElement(_pricing_composition_history2.default, {
        cusip: this.props.cusip,
        country: this.props.country,
        role: this.props.role,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        data: this.props.historicalData.pricingCompositionHistoryList,
        formattingRules: this.props.fund.visibleData.formattingRules,
        disclosureText: this.props.fund.disclosures.pdpCardNAVComposition,
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isETFHistoricalNAVMarketPrice = (0, _ramda.includes)('ETF_HISTORICAL_NAV_MARKET_PRICE', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund));
      var isETFHistoricalNAVPrice = (0, _ramda.includes)('ETF_HISTORICAL_NAV_PRICE', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund));
      var isETFHistoricalNAVVIIV = (0, _ramda.includes)('ETF_HISTORICAL_NAV_VIIV', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund));
      var commonChartProps = {
        active: this.props.active,
        breakpoint: this.props.breakpoint,
        cusip: this.props.cusip,
        country: this.props.country,
        fund: this.props.fund,
        language: this.props.language,
        role: this.props.role,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        tooltip: this.props.tooltip,
        window: this.props.window
      };
      var showExtraDisclosureForSG = (0, _functional_utility.doesVisibleDataPointContains)("HISTORICAL_NAV_CHART_EXTRA_DISCLOSURE", this.props);
      var extraDisclosureProps = {
        extraDisclosureText: showExtraDisclosureForSG ? (0, _functional_utility.pathOrNull)(["fund", "disclosures", "pdpCardHistoricalPriceChartNAV"], this.props) : null,
        extraPlacementId: showExtraDisclosureForSG ? "pdpCardHistoricalPriceChartNAV" : null
      };
      var disclosureProps = {
        disclosureText: isETFHistoricalNAVMarketPrice ? (0, _functional_utility.pathOrNull)(["fund", "disclosures", "pdpCardHistoricalNAVMarketPrice"], this.props) : (0, _functional_utility.pathOrNull)(["fund", "disclosures", "pdpCardHistoricalPriceChart"], this.props),
        placementId: isETFHistoricalNAVMarketPrice ? "pdpCardHistoricalNAVMarketPrice" : "pdpCardHistoricalPriceChart"
      };

      var historicalNAVList = (0, _functional_utility.pathOrEmptyArray)(["historicalData", isETFHistoricalNAVMarketPrice || isETFHistoricalNAVPrice ? "historicalETFClosingPriceList" : "historicalNAVList"], this.props);
      var containsBelgianTisRates = this.props.historicalData.containsBelgianTisRates;
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 print-full-width' },
        !(0, _functional_utility.isNilOrEmpty)(historicalNAVList) && _react2.default.createElement(_nav_history_chart_parent2.default, _extends({}, commonChartProps, disclosureProps, extraDisclosureProps, {
          historicalNAVList: historicalNAVList,
          dataPointKey: 'navPrice',
          decimalPlaces: this.decimalPlaces(),
          id: 'nav-history',
          'data-testid': 'nav-history-chart-parent',
          downloadType: 'historicalNav',
          headerTitle: _string_utility2.default.renderFormattedLabel("Historical NAV", isETFHistoricalNAVVIIV ? "pdp-historical-price-title-with-viiv" : "pdp-historical-price-title", {
            fundTypeCode: this.props.fund.fundTypeCode,
            role: this.props.role
          }),
          headerTitleId: "historicalnav",
          headerTitleLabel: "historicalnav-chart-header",
          shareClassLaunchDate: this.props.fund.shareClassLaunchDate,
          currencyCode: _currency_utility2.default.getCurrencyMapping(this.props.fund.shareClass.currencyCode, this.props.country),
          isFlatMode: this.props.isFlatMode,
          intl: this.props.intl
        })),
        (0, _ramda.includes)('HISTORICAL_MARKET_NAV', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund)) && !(0, _functional_utility.isNilOrEmpty)(this.props.historicalData.historicalNAVList) && _react2.default.createElement(_nav_history_chart_parent2.default, _extends({}, commonChartProps, {
          historicalNAVList: _collection_utility.CollectionUtility.filter(this.props.historicalData.historicalNAVList, function (o) {
            return !(0, _ramda.isNil)(o.marketBasedNAVPrice);
          }),
          dataPointKey: 'marketBasedNAVPrice',
          decimalPlaces: 4,
          id: 'market-nav-history',
          'data-testid': 'market-nav-history-chart-parent',
          tooltipImpl: this.tooltipImpl,
          downloadType: 'historicalMarketNav',
          disclosureText: this.props.fund.disclosures.pdpCardNAVDifferenceChart,
          placementId: "pdpCardNAVDifferenceChart",
          headerTitle: (0, _string_utility.renderFormattedLabel)("Historical market-based NAV", "pdp-historical-chart-market-nav-header"),
          headerTitleId: "historicalmarketnav",
          headerTitleLabel: "historical-market-nav-chart-header",
          currencyCode: _currency_utility2.default.getCurrencyMapping(this.props.fund.shareClass.currencyCode, this.props.country),
          isFlatMode: this.props.isFlatMode,
          intl: this.props.intl
        })),
        !(0, _functional_utility.isNilOrEmpty)(containsBelgianTisRates) && containsBelgianTisRates && _react2.default.createElement(_belgian_tis_rates_card2.default, _extends({}, commonChartProps, {
          historicalNAVList: historicalNAVList,
          breakpoint: this.props.breakpoint,
          intl: this.props.intl,
          tooltipImpl: this.tooltipImpl,
          downloadType: 'belgianTisRates',
          id: 'belgianTisRates'
        })),
        this.renderPricingCompositionHistoryCard()
      );
    }
  }, {
    key: 'decimalPlaces',
    value: function decimalPlaces() {
      var result = (0, _pathOr2.default)(2, ["shareClass", "nav", "navDecimalPoints"], this.props.fund);

      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "NAV_DECIMAL_PLACES_UNLIMITED")) {
        return result;
      }

      if (this.props.historicalData.fundTypeCode === "N_ETF") {
        if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "ETF_HISTORICAL_NAV_MARKET_PRICE") || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "ETF_HISTORICAL_NAV_PRICE") || _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "HISTORICAL_NAV_CHART_HOVER_VALUE_TWO_DP")) {
          result = 2;
        } else {
          result = 4;
        }
      } else if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "HISTORICAL_CHART_DATA_SHOW_IN_FOUR_DECIMAL")) {
        result = 4;
      }

      return result;
    }
  }]);

  return FundHistoricalPrices;
}(_react2.default.Component);

exports.default = FundHistoricalPrices;